<template>
	<div v-if="exoticCategory" class="ExoticBadge">
		<button class="ExoticBadge" :class="{'ExoticBadge--xs': size == 'xs'}" :title="$t(`exotic.categoryLabel`, [$t(`exotic.category${exoticCategory}.title`)])" v-clo-tooltip  @click="showDialog" >
			<CloIcon v-if="exoticCategory === 'N'" symbol="exoticNaturalized"/>
			<CloIcon v-if="exoticCategory === 'P'" symbol="exoticProvisional"/>
			<CloIcon v-if="exoticCategory === 'X'" symbol="exoticEscapee"/>
		</button>
		<!-- Exotic dialog -->
		<CloDialog v-show="dialogOpen" id="exotic-dialog" class="ExoticBadge-dialog" @close="closeDialog">
			<template #header>
				<CloHeading level="4" size="2" class="u-stack-sm">{{ $t('exotic.title') }}</CloHeading>
			</template>
			<template #body>
				<p>{{ $t('exotic.desc') }}</p>
				<ul class="u-unlist u-stack-md">
					<li>
						<CloIcon symbol="exoticNaturalized" size="sm" />
						<span><strong>{{ $t('exotic.categoryN.title') }}</strong>: {{ $t('exotic.categoryN.desc') }}</span>
					</li>
					<li>
						<CloIcon symbol="exoticProvisional" size="sm" />
						<span><strong>{{ $t('exotic.categoryP.title') }}</strong>: {{ $t('exotic.categoryP.desc') }}</span>
					</li>
					<li>
						<CloIcon symbol="exoticEscapee" size="sm" />
						<span><strong>{{ $t('exotic.categoryX.title') }}</strong>: {{ $t('exotic.categoryX.desc') }}</span>
					</li>
				</ul>
			</template>
			<template #footer>
				<a href="https://support.ebird.org/support/solutions/articles/48001218430" class="Button">{{ $t('generic.learnMore') }}</a>
			</template>
		</CloDialog>
	</div>
</template>

<script>
export default {
	name: 'ExoticBadge',
	components: {},
	props: {
		exoticCategory: {
			type: String,
			required: true,
		},
		size: {
			type: String,
			default: "sm",
		},
	},
	computed: {
	},
	data() {
		return {
			dialogOpen: false,
			dialogOpener: null,
		};
	},
	methods: {
		showDialog(e) {
			this.dialogOpen = true;
			this.dialogOpener = e.target;
		},
		closeDialog() {
			this.dialogOpen = false;
			// important: put focus back on element that triggered the dialog
			if (this.dialogOpener) {
				this.dialogOpener.focus();
			}
		},
	}
};
</script>

<style lang="scss">
	.ExoticBadge {
		.Icon {
			width: $space-md;
			height: $space-md;
		}
		&--xs {
			.Icon {
				width: ($space-md - $space-xs);
				height: ($space-md - $space-xs);
				transform: translateY(-14%);
			}
		}
		.ExoticBadge-dialog {
			@include text(4);
			p {
				margin-bottom: $space-sm;
			}
			ul {
				@include text(3);
			}
			li {
				display: flex;
				gap: $space-sm;
				align-items: baseline;
				margin-bottom: $space-sm;
				.Icon {
					flex: 0 0 auto;
					transform: translateY(15%);
				}
			}
		}
	}
</style>
